import * as ActionTypes from './ActionTypes';
export const BulkPayrollLoadAction = (isLoading) => {
    return {
        type: ActionTypes.FINANCE_BULK_LOAD,
        params: { isLoading }
    }
};
